'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive('tlFocusInit', function ($window) {
  var timer;
  return function (scope, elm, attr) {
    if (timer) {
      $window.clearTimeout(timer);
    }
    timer = $window.setTimeout(function () {
      elm.focus();
    }, 0);
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/tl/tlFocusInit.js
// module id = 2902
// module chunks = 13